import React, { useRef } from "react";
import {
  Autocomplete,
  Backdrop,
  BackdropRoot,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  TextField,
  ThemeProvider,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import CancelIcon from "@mui/icons-material/Cancel";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useEffect, useState, useMemo } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { createTheme } from "@mui/material/styles";

import { toast } from "react-toastify";
import axios from "axios";
import { ToastContainer } from "react-toastify/dist";
import Loader from "../../../../components/Loader";

import InputLabel from "@mui/material/InputLabel";

// tablle imports

import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";

import { useDispatch, useSelector } from "react-redux";
import { setemployeebutton } from "../../../../redux/features/EmployeeSlice";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { useImmer } from "use-immer";
import { common_axios } from "../../../../App";
import Swal from "sweetalert2";

export default function CSMEmployeeLeave() {
  const [open, setOpen] = useState(false);
  const [state, setstate] = useState("");
  const [stateData, setstateData] = useState([]);
  const [location, setLocation] = React.useState({
    leaveType: "",
    reason: "",
    showlastdiv: false,
  });
  const [data, setData] = useState([]);
  const [showdata, setshowData] = useState(false);
  const [value, setValue] = React.useState(null);
  const [valuee, setValuee] = React.useState(null);
  const [buttonDisable, setbuttonDisable] = useState(false);
  // const [leaves, setLeaves] = useImmer([]);
  const [leaves, setLeaves] = useState({
    mapped: [],
    value1: "",
  });
  const [modalOpen, setmodalOpen] = useState(false);

  const [employees, setEmployess] = useState([]);
  const [employeesValue, setEmployessValue] = useState(null);
  const [daysDiff, setdaysDiff] = useState(1);
  const [guptaSaab, setguptaSaab] = useState("");

  const handleChange = (newValue) => {
    setValue(newValue);
  };
  const handleChangee = (newValue) => {
    setValuee(newValue);
  };
  var date = moment(valuee?.$d);
  var now = moment(value?.$d);
  var duration = moment.duration(date.diff(now));
  var noofDays = duration.asDays();

  // const nowDate = JSON.parse(now);
  // const afterDate = JSON.parse(date);
  // var date1 = moment("2022-10-30");
  // var date2 = moment("2022-12-30");
  // var days = date1.diff(date2, "days");

  // console.log({ nowDate, afterDate });

  // var noofDays = date?.diff(now, "days");
  // const noofDays = "";

  useEffect(() => {
    setdaysDiff(Math.ceil(noofDays) + 1);
  }, [value?.$d, valuee?.$d]);

  //   let days = noofDays.slice(0, 1);

  const { globalFilter, pageIndex, pageSize } = state;

  const textareaRef = useRef();
  const cursorPosition = 20;

  const nameoferr = () => {
    setguptaSaab("End Date Should Be Greater Than Start Date");
  };

  useEffect(() => {
    nameoferr();
  }, [guptaSaab]);

  const columns = useMemo(
    () => [
      {
        Header: "S.no",

        accessor: "S.no",
        Cell: (cell) => {
          return <>{cell.row.index + 1}</>;
        },
      },

      {
        Header: "Name",

        accessor: "name",
      },
      {
        Header: "City",

        accessor: "city",
      },
      {
        Header: "Contact No.",

        accessor: "contact",
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    // state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
    palette: {
      primary: {
        main: "#FFA500", //this overide blue color
        // light: "#fff", //overides light blue
        // dark: "#fff", //overides dark blue color
      },
    },
  });

  const resetValues = useRef(null);
  const nextPageRef = useRef(null);

  const resetter = () => {
    resetValues?.current?.click();
  };
  const nextPageReference = () => {
    nextPageRef?.current.click();
  };

  // const allLocations = async () => {
  //   try {
  //     setOpen(true);
  //     const res = await axios(
  //       `${process.env.REACT_APP_COMMON_API}/location/getAllLocations`
  //     );

  //     if (res.data.responseStatus.statusCode == 200) {
  //       // setData(res.data.response.locations);
  //       setOpen(false);
  //     } else {
  //       setOpen(false);
  //       await toast.error(res.data.responseStatus.statusDescription);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     setOpen(false);
  //     await toast.error("Something went wrong !! Please check your network");
  //   }
  // };
  const role = JSON.parse(localStorage.getItem("Sidebaritems"))?.name;

  const userModal = JSON.parse(localStorage.getItem("usermodal"))?.userGroups;

  const typeofLeaves = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `attendance/selfLeaves?userGroup=${employeesValue?.userGroups}`
      );

      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);

        setLeaves({
          ...leaves,
          mapped: res.data.attendanceDetailsModels,
        });
      } else {
        setOpen(false);
        // await toast.error(res.data.statusDescriptions.statusDescription, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      // await toast.error("Something Went Wrong !! Please check your network ", {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  useEffect(() => {
    if (employeesValue?.userGroups) {
      typeofLeaves();
    }
  }, [employeesValue?.userGroups]);

  const getAllEmployeesbyCSM = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `/employee/allEmployeeByCsm?id=${localStorage.getItem("UserId")}`
      );

      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);

        setEmployess(res.data.adminUserModels);

        // x.toLocaleDateString()
      } else {
        setOpen(false);
        // await toast.error(res.data.statusDescriptions.statusDescription, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      // await toast.error("Something Went Wrong !! Please check your network ", {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("Sidebaritems"))?.name != "Employee") {
      getAllEmployeesbyCSM();
    }
  }, []);

  const usermodal = JSON.parse(localStorage.getItem("usermodal"))?.userGroups;

  const validationSchema = yup.object({
    name: yup
      .string("Enter your Name")
      .min(3, "Name should be of minimum 3 characters length")

      .max(30, "Name should be of maximum 30 characters length")
      .required("Name is required")
      .when("role", () => {
        if (role == "Employee") {
          return yup
            .string()
            .required("Name is required")
            .min(3, "Name should be of minimum 3 characters length")
            .max(20, "Name should be of maximum 5 characters length");
        }
      }),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,

    // validationSchema: validationSchema,

    onSubmit: async (e, values) => {
      try {
        await LeaveSure();
        if (modalOpen == true) {
          setOpen(true);
          const res = await common_axios.post(`attendance/markAttendance`, {
            userId: employeesValue?.id,
            userGroup: usermodal,
            userName: localStorage.getItem("usernamedisplayed"),

            numberOfDays: daysDiff.toString(),
            status: leaves.value1?.toString(),
            reason: location.reason,
            fromDate: moment(value?.$d).format("YYYY-MM-DD"),
            toDate: moment(valuee?.$d).format("YYYY-MM-DD"),
          });
          if (res.data.statusDescriptions.statusCode == 200) {
            setOpen(false);

            await formik.handleReset();
            await resetter();
            await setshowData(true);
            await setValue(null);
            await setmodalOpen(false);
            // await setValuee(dayjs(new Date()));
            await setdaysDiff(1);

            await setTimeout(async () => {
              // await toast.success(
              //   res.data.statusDescriptions.statusDescription,
              //   {
              //     theme: "colored",
              //   }
              // );
              Swal.fire({
                icon: "success",
                // title: "Oops...",
                text: res.data.statusDescriptions.statusDescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }, 100);
          } else {
            setOpen(false);
            await setmodalOpen(false);
            await setTimeout(async () => {
              // await toast.error(res.data.statusDescriptions.statusDescription, {
              //   theme: "colored",
              // });
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: res.data.statusDescriptions.statusDescription,
                // footer: '<a href="">Why do I have this issue?</a>'
              });
            }, 100);
          }
        }
      } catch (error) {
        setOpen(false);
        console.log(error);
        await setmodalOpen(false);
        await setTimeout(async () => {
          // await toast.error(
          //   "Something went wrong !! Please check your network",
          //   {
          //     theme: "colored",
          //   }
          // );
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something Went Wrong !! Please check your network ",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      }
    },
  });

  const getButtonAdd = useSelector(
    (data) => data?.EmployeeSlice?.employeebutton
  );
  const dispatch = useDispatch();

  const applyLeave = useRef(null);

  const LeaveSure = async () => {
    await setmodalOpen(true);
    await applyLeave.current.click();
  };
  const onKeyDown = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <button
        ref={applyLeave}
        type="button"
        className="btn btn-primary d-none"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdrop11"
      >
        Launch static backdrop modal
      </button>
      <div
        className="modal profile_details fade"
        id="staticBackdrop11"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content" style={{ top: "10rem" }}>
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Leave Application ?
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setmodalOpen(false);
                }}
              ></button>
            </div>
            {/* <form onSubmit={formik.handleSubmit}> */}
            <ThemeProvider theme={theme}>
              <div className="modal-body">
                <div className="text-center">
                  <h5>Are you sure to submit this application ?</h5>
                </div>
              </div>
              <hr />
            </ThemeProvider>
            {/* </form> */}
            {/* modal-footer */}
            <div className="px-2 pb-3">
              <div className="d-flex justify-content-between align-items-center">
                <Button
                  onClick={() => {
                    setmodalOpen(false);
                  }}
                  style={{ marginLeft: "4px" }}
                  data-bs-dismiss="modal"
                  type="button"
                  variant="contained"
                  sx={{ background: "#4C4234", color: "white" }}
                  endIcon={<CancelIcon />}
                >
                  No
                </Button>
                <div className="text-end">
                  <Button
                    onClick={() => {
                      formik.handleSubmit();
                    }}
                    data-bs-dismiss="modal"
                    type="submit"
                    variant="contained"
                    sx={{ background: "#F96B02", color: "white" }}
                    endIcon={<CheckCircleIcon />}
                  >
                    Yes
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
      <section class="form_card mt-5">
        <ToastContainer autoClose={5000} />

        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>

        <div class="container-fluid" id="cont_fluid">
          <div class="card d-block" id="new_store_entry">
            <div
              class="card-header p-3 position-relative border-0 bg-white"
              id="card_headr"
            >
              <div class="ttl_bx position-absolute d-flex mt_n4">
                <i class="fas fa-user d-block m-auto"></i>
              </div>
              <div class="d-flex justify-content-between title_8 ms_5 px-2">
                <p>Request Leave</p>
                <p class="text-sm mb-0 text-capitalize fw-bold">
                  Fields with!!
                  <span class="text-danger fw-bold">*</span> are mandatory.
                </p>
              </div>
              <div></div>
            </div>

            <div class="card-body p-4 mt-5 tab-content" id="myTabContent">
              <div
                class="tab-pane fade show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <form onSubmit={formik.handleSubmit} class="m-0">
                  <div class="card card_8 d-block">
                    <div class="d-flex align-items-center w_30 mt_n3 ms-5 me-auto">
                      <i class="fas fa-envelope d-block" aria-hidden="true"></i>
                      <span class="d-block w-100 text-uppercase ms-2">
                        leave form
                      </span>
                    </div>
                    {(value?.$d && valuee?.$d != undefined) || null ? (
                      <p class="text-end me-3 fw-bold">
                        No of Leave Days : {daysDiff}
                      </p>
                    ) : null}
                    <div class="card-body">
                      <ThemeProvider theme={theme}>
                        <div className="formisform">
                          <div class="row">
                            <div
                              className={
                                JSON.parse(localStorage.getItem("Sidebaritems"))
                                  ?.userGroups != 6
                                  ? "col-md-3"
                                  : "col-md-4"
                              }
                            >
                              <Autocomplete
                                fullWidth
                                required
                                size="small"
                                disablePortal
                                id="combo-box-demo"
                                options={employees}
                                getOptionLabel={(option) =>
                                  `${option.firstName}` +
                                  " " +
                                  `${option.lastName}`
                                }
                                value={employeesValue}
                                onChange={(e, val) => {
                                  setEmployessValue(val);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    required
                                    {...params}
                                    size="small"
                                    label="Employee Name"
                                  />
                                )}
                              />
                            </div>

                            <div
                              className={
                                JSON.parse(localStorage.getItem("Sidebaritems"))
                                  ?.userGroups != 6
                                  ? "col-md-3"
                                  : "col-md-4"
                              }
                            >
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Stack spacing={3}>
                                  <DesktopDatePicker
                                    minDate={dayjs(new Date())}
                                    label="Start Date"
                                    inputFormat="DD/MM/YYYY"
                                    value={value}
                                    // onError={(e) => {
                                    //   if (e) {
                                    //     setguptaSaab(true);
                                    //     setbuttonDisable(true);
                                    //   } else {
                                    //     setguptaSaab(false);
                                    //     setbuttonDisable(false);
                                    //   }
                                    // }}
                                    onChange={(e) => {
                                      handleChange(e);
                                      setValuee(null);
                                      setLeaves({
                                        ...leaves,
                                        value1: null,
                                      });
                                      // setEmployessValue(null);
                                      setLocation({
                                        leavetype: "",
                                        reason: "",
                                      });
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        onFocus={(e) => e.target.blur()}
                                        required
                                        size="small"
                                        onKeyDown={onKeyDown}
                                        {...params}
                                        inputProps={{
                                          // ...params.inputProps,
                                          readOnly: true,
                                        }}
                                      />
                                    )}
                                  />
                                </Stack>
                              </LocalizationProvider>
                            </div>

                            <div
                              className={
                                JSON.parse(localStorage.getItem("Sidebaritems"))
                                  ?.userGroups != 6
                                  ? "col-md-3"
                                  : "col-md-4"
                              }
                              id="date_cal"
                            >
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Stack spacing={3}>
                                  <DesktopDatePicker
                                    label="End Date"
                                    onError={(e) => {
                                      if (e) {
                                        setguptaSaab(true);
                                        setbuttonDisable(true);
                                      } else {
                                        setguptaSaab(false);
                                        setbuttonDisable(false);
                                      }
                                    }}
                                    minDate={dayjs(value?.$d)}
                                    inputFormat="DD/MM/YYYY"
                                    value={valuee}
                                    onChange={(e) => {
                                      handleChangee(e);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        required
                                        size="small"
                                        {...params}
                                        onKeyDown={onKeyDown}
                                        // inputProps={{
                                        //   ...params.inputProps,
                                        //   readOnly: true,
                                        // }}
                                      />
                                    )}
                                  />
                                </Stack>
                              </LocalizationProvider>
                            </div>

                            {employeesValue?.userGroups != null || undefined ? (
                              <div
                                className={
                                  JSON.parse(
                                    localStorage.getItem("Sidebaritems")
                                  )?.userGroups != 6
                                    ? "col-md-3"
                                    : "col-md-4 mt_3"
                                }
                              >
                                <FormControl required fullWidth>
                                  <InputLabel
                                    size="small"
                                    id="demo-simple-select-label"
                                  >
                                    Leave Type
                                  </InputLabel>
                                  <Select
                                    size="small"
                                    required
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={leaves.value1}
                                    label="Leave Type"
                                    onChange={(e) => {
                                      setLeaves({
                                        ...leaves,
                                        value1: e.target.value,
                                      });
                                    }}
                                  >
                                    {/* {locationdaata?.map((lo) => {
                                    console.log(lo);
                                    return (
                                      <MenuItem
                                        value={lo.locationclassificationid}
                                      >
                                        {lo.locationclassification}
                                      </MenuItem>
                                    );
                                  })} */}
                                    {leaves?.mapped?.map((e) => {
                                      return (
                                        <MenuItem value={e.status}>
                                          {e.name}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                              </div>
                            ) : null}
                          </div>

                          <>
                            {/* {daysDiff > 0 ? ( */}
                            <>
                              <div class="col-md-12 mt-2">
                                <label
                                  for="exampleFormControlTextarea1"
                                  class="form-label fw-bold"
                                  style={{
                                    fontSize: "1rem",
                                    color: "#000",
                                  }}
                                >
                                  Reason for Leave:
                                </label>
                                <textarea
                                  onBlur={() =>
                                    textareaRef.current.setSelectionRange(
                                      cursorPosition,
                                      cursorPosition
                                    )
                                  }
                                  ref={textareaRef}
                                  style={{
                                    height: "70px",
                                    maxHeight: "150px",
                                    minHeight: "60px",
                                    width: "400px",
                                    maxWidth: "100%",
                                    minWidth: "100%",
                                    padding: "8px",
                                  }}
                                  maxlength="100"
                                  placeholder="Reason for Leave"
                                  value={location?.reason}
                                  required
                                  // onChange={handleChangetext}
                                  onChange={(e) => {
                                    setLocation({
                                      ...location,
                                      reason: e.target.value,
                                    });
                                  }}
                                  class="form-control"
                                  id="exampleFormControlTextarea1"
                                  rows="3"
                                ></textarea>
                              </div>
                              <p class="text-sm mb-0 text-capitalize character_P">
                                Maximum 100 characters Allowed
                                <span class="text-danger ">*</span>
                              </p>
                            </>
                            {/* ) : null} */}
                          </>

                          <>
                            {location.reason ? (
                              <p className="character_P">
                                Characters Used :{location?.reason?.length}
                              </p>
                            ) : null}
                          </>
                        </div>
                      </ThemeProvider>
                      <div class="d-flex justify-content-between align-items-center my-4">
                        <Button
                          ref={resetValues}
                          onClick={() => {
                            formik.handleReset();
                            setLocation({
                              leavetype: "",
                              reason: "",
                            });
                            setLeaves({
                              ...leaves,
                              value1: null,
                            });
                            setEmployessValue(null);
                            setValue(null);
                            setValuee(null);
                          }}
                          sx={{ marginLeft: "10px", background: "#4C4234" }}
                          type="reset"
                          variant="contained"
                          endIcon={<RestartAltIcon />}
                        >
                          Clear
                        </Button>
                        <Button
                          type="submit"
                          disabled={buttonDisable}
                          variant="contained"
                          sx={{ background: "#F67503" }}
                          endIcon={<SendIcon />}
                        >
                          Submit
                        </Button>
                      </div>
                      {/* <div className="text-end">
                        <p> List of Pending Leaves</p>
                        <Link className="primary" to="/dashboard/LeaveStatus">
                          <p style={{ color: "#F47C03" }}>Click here !!</p>
                        </Link>
                      </div> */}
                    </div>
                  </div>
                </form>
              </div>

              {/* </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
